export default __webpack_public_path__ + "static/media/instagramFooter.0ff2cc06.svg";